//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'
import footerNav from '@/components/footerNav'

export default {
  name: "refundOrderDetailMore",
  components: {
    footerNav
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    toAll(){
      this.$router.push({name:'refundOrderDetailAll'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/refundOrder/detailMore.vue